import { render, staticRenderFns } from "./ShowonMapThuraya.vue?vue&type=template&id=72de37aa&scoped=true&"
import script from "./ShowonMapThuraya.vue?vue&type=script&lang=js&"
export * from "./ShowonMapThuraya.vue?vue&type=script&lang=js&"
import style0 from "./ShowonMapThuraya.vue?vue&type=style&index=0&id=72de37aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de37aa",
  null
  
)

export default component.exports